<template>
  <div class="calico-conversation-container">
    <ConversationsWidget 
      :conversations="conversations" 
      @new-chat="handleNewChat" 
    />
  </div>
</template>

<script>
import ConversationsWidget from '@/components/widget/conversations/index.vue';

export default {
  name: 'ConversationsWidgetPage',
  components: { ConversationsWidget },
  data() {
    return {
      conversations: [
        {
          id: 30,
          user_id: 5,
          business_id: 3,
          model: "gemini-1.5-flash-002",
          title: "Burga: History, Culture, and More",
          history: [
            { role: "user", parts: [{ text: "cuéntame acerca de Burga" }] },
            { role: "model", parts: [{ text: "Burga Republic es un restaurante de hamburguesas..." }] }
          ],
          createdAt: new Date(),
          updatedAt: "2025-03-31T19:21:27.728Z"
        },
        {
          id: 30,
          user_id: 5,
          business_id: 3,
          model: "gemini-1.5-flash-002",
          title: "Burga: History, Culture, and More",
          history: [
            { role: "user", parts: [{ text: "cuéntame acerca de Burga" }] },
            { role: "model", parts: [{ text: "Burga Republic es un restaurante de hamburguesas..." }] }
          ],
          createdAt: "2025-04-08T19:21:27.728Z",
          updatedAt: "2025-04-08T19:21:27.728Z"
        },
        {
          id: 36,
          user_id: 5,
          business_id: 3,
          model: "gemini-1.5-flash-002",
          title: "Burga: History, Culture, and More",
          history: [
            { role: "user", parts: [{ text: "cuéntame acerca de Burga" }] },
            { role: "model", parts: [{ text: "Burga Republic es un restaurante de hamburguesas..." }] }
          ],
          createdAt: "2025-03-31T19:21:25.844Z",
          updatedAt: "2025-03-31T19:21:27.728Z"
        },
        {
          id: 35,
          user_id: 5,
          business_id: 3,
          model: "gemini-1.5-flash-002",
          title: "Hola: A Spanish Greeting",
          history: [{ role: "user", parts: [{ text: "Hola" }] }],
          createdAt: "2025-04-01T10:00:00.000Z",
          updatedAt: "2025-04-01T10:05:00.000Z"
        },
        {
          id: 37,
          user_id: 5,
          business_id: 3,
          model: "gemini-1.5-flash-002",
          title: "Burgdasfasfdsa",
          history: [
            { role: "user", parts: [{ text: "cuéntame acerca de Burga" }] },
            { role: "model", parts: [{ text: "Burga Republic es un restaurante de hamburguesas..." }] }
          ],
          createdAt: "2024-03-29T19:21:25.844Z",
          updatedAt: "2025-03-31T19:21:27.728Z"
        },
        {
          id: 38,
          user_id: 5,
          business_id: 3,
          model: "gemini-1.5-flash-002",
          title: "Burger",
          history: [
            { role: "user", parts: [{ text: "cuéntame acerca de Burga" }] },
            { role: "model", parts: [{ text: "Burga Republic es un restaurante de hamburguesas..." }] }
          ],
          createdAt: "2025-02-31T19:21:25.844Z",
          updatedAt: "2025-03-31T19:21:27.728Z"
        },
      ]
    };
  },
  methods: {
    handleNewChat() {
      console.log("New chat");  
    }
  }
};
</script>
<style lang="scss">
.calico-conversation-container{
  padding: $space-large;
}
</style>
